import { useEffect, useState } from 'react';
import { DeviceType } from '@/utils/getDeviceType';
import { usePageContext } from '@/contexts';

export const useResponsive = () => {
  const { deviceType } = usePageContext();

  const [{ isMobile, isTablet, isDesktop }, setDeviceType] = useState({
    isMobile: deviceType === DeviceType.Mobile,
    isTablet: deviceType === DeviceType.Tablet,
    isDesktop: ![DeviceType.Mobile, DeviceType.Tablet].includes(
      deviceType ?? DeviceType.Desktop
    ),
  });

  useEffect(() => {
    const largeQuery = window.matchMedia('(min-width: 950px)');
    const mediumQuery = window.matchMedia(
      '(min-width: 744px) and (max-width: 949px)'
    );

    const updateDeviceType = () => {
      setDeviceType({
        isDesktop: largeQuery.matches,
        isTablet: mediumQuery.matches,
        isMobile: !largeQuery.matches && !mediumQuery.matches,
      });
    };

    updateDeviceType();

    largeQuery.addEventListener('change', updateDeviceType);
    mediumQuery.addEventListener('change', updateDeviceType);

    return () => {
      largeQuery.removeEventListener('change', updateDeviceType);
      mediumQuery.removeEventListener('change', updateDeviceType);
    };
  }, []);

  return {
    isMobile,
    isTablet,
    isDesktop,
  };
};
